var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.localErrors),function(error){return _c('li',{key:error,staticClass:"text-danger"},[_vm._v(" "+_vm._s(error)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }